import React from 'react';
import moment from 'moment-timezone';
const DateCell = (props) => {
    const timeZone = props.timeZone ? props.timeZone : 'America/New_York';
    const updated_date = moment(props.value).tz(timeZone).format('MM/DD/YYYY hh:mm A');
    return (React.createElement("div", { style: { width: 80, zoom: 0.8 } }, `${updated_date}`));
};
export default DateCell;
//# sourceMappingURL=DateCell.js.map